export default __webpack_public_path__ + "videos/collab-editor.40d2457b570ba105e0706cdc9ab71558.mov";